import { lazy, useEffect, Suspense } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Loading, Layout } from 'common/components/layout';
import { retry } from 'common/helpers/routerHelper';
import { useLocalization } from 'redux/localization/utils/hooks';
import { listReservationTypes } from 'redux/reservationTypes/actions';

const LoadableComponent = lazy(() => retry(() => import('./App')));

const AppLoader = () => {
  const dispatch = useDispatch();
  const { t } = useLocalization();

  const reservationTypeReducer = useSelector((state) => state.reservationType);

  useEffect(() => {
    dispatch(listReservationTypes());
  }, [dispatch]);

  if (reservationTypeReducer.isListFetching || !reservationTypeReducer.data) {
    return <Loading />;
  }

  return (
    <Layout title={t('reservation.booking.reservationAvailability')}>
      <Suspense fallback={<Loading />}>
        <LoadableComponent />
      </Suspense>
    </Layout>
  );
};

export default AppLoader;
